import { LegalPage, LegalH, LegalP } from "../components/LegalPage";

export default function TerminiDiVendita() {
  return (
    <LegalPage title="Termini di Vendita" subtitle="Condizioni generali di contratto per i servizi di coaching online MP Coaching">
      <LegalH>1. Oggetto</LegalH>
      <LegalP>
        I presenti termini regolano l'acquisto dei pacchetti di coaching online offerti da MP Coaching
        (P.IVA 13527260015, con sede in Via Fratelli Garrone 79, Torino):
        Basic (6 settimane, 89€), Premium (12 settimane, 149€)
        e Premium Extended (12 mesi, 799€). I servizi consistono in programmi di allenamento personalizzati,
        supporto tramite app dedicata e, a seconda del pacchetto, programma alimentare, indicazioni sull'integrazione
        e supporto via chat.
      </LegalP>
      <LegalH>2. Prezzi e pagamento</LegalH>
      <LegalP>
        I prezzi indicati sono in Euro e comprensivi di IVA dove applicabile. Il pagamento avviene in un'unica
        soluzione al momento dell'ordine tramite Stripe (carta di credito/debito, Apple Pay, Google Pay).
        Nessun rinnovo automatico è previsto.
      </LegalP>
      <LegalH>3. Erogazione del servizio</LegalH>
      <LegalP>
        Dopo la conferma del pagamento riceverai via email le istruzioni per accedere all'app e compilare il
        questionario iniziale. Il programma personalizzato viene elaborato a seguito del questionario e reso
        disponibile direttamente in app.
      </LegalP>
      <LegalH>4. Natura del servizio — avvertenze</LegalH>
      <LegalP>
        I programmi di allenamento e le indicazioni alimentari e di integrazione hanno finalità di benessere e
        fitness e non costituiscono prestazione sanitaria. Non sostituiscono il parere del medico. Prima di iniziare
        qualsiasi programma di attività fisica, in particolare in presenza di patologie o condizioni particolari,
        consulta il tuo medico. I risultati possono variare da persona a persona e dipendono dall'impegno individuale.
      </LegalP>
      <LegalH>5. Responsabilità</LegalH>
      <LegalP>
        L'esecuzione degli esercizi avviene sotto la tua esclusiva responsabilità. È tua cura segnalare tramite il
        questionario e il supporto chat eventuali condizioni fisiche rilevanti per la corretta personalizzazione
        del programma.
      </LegalP>
      <LegalH>6. Recesso e rimborsi</LegalH>
      <LegalP>
        Si applica quanto previsto nella pagina Diritto di Recesso, ai sensi del D.Lgs. 206/2005 (Codice del Consumo).
      </LegalP>
      <LegalH>7. Legge applicabile e foro</LegalH>
      <LegalP>
        Il contratto è regolato dalla legge italiana. Per le controversie è competente il foro del consumatore.
        È inoltre disponibile la piattaforma europea ODR per la risoluzione online delle controversie:
        https://ec.europa.eu/consumers/odr.
      </LegalP>
    </LegalPage>
  );
}
